import { PLATFORMS } from '../utils/constants';
import { nuvemshopService as ncs } from './mobilizei/nuvemshop.service';
import { trayService as tcs } from './mobilizei/tray.service';
import { mapNuvemCategories } from '../utils/mappers/nuvemshop';
import { mapTrayCategories } from '../utils/mappers/tray';

export const categoriesServices = {
    getAllCategories
};

function getAllCategories(platformId, storeId, accessToken) {
    let queryMethod = null;
    let mapperMethod = null;
    if (platformId === PLATFORMS.NUVEMSHOP) {
        queryMethod = ncs.getAllCategories;
        mapperMethod = mapNuvemCategories;
    } else {
        queryMethod = tcs.getAllCategories;
        mapperMethod = mapTrayCategories;
    }

    return queryMethod(storeId, 1, [], accessToken).then(response => {
        const categories = mapperMethod(response);
        return categories;
    })
}